import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tab, Tabs, Grid, Badge, Divider, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { setDepartment, statisticUnaccepted, getProfileInfoByProfileId } from "../../../reducer/profile/action";
import { getAllDepartments } from "../../../reducer/department/action";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import Patent from "../../../components/Patent";
import Project from "../../../components/Project";
import Solution from "../../../components/Solution";
import Monograph from "../../../components/Monograph";
import Exhibition from "../../../components/Exhibition";
import Achievement from "../../../components/Achievement";
import StudentGuidance from "../../../components/StudentGuidance";
import ScientificCouncilNew from "../../../components/ScientificCouncilNew";
import ScientificResearch from "../../../components/ScientificResearch";

function ManagementTab(props) {
  const [value, setValue] = useState(0);
  const [count, setCount] = useState({});
  const [department, setDepartment] = useState(null);

  const handleChangeDepartment = (val) => setDepartment(val);
  const handleChange = (event, newValue) => setValue(newValue);
  const handleReload = () => props.statisticUnaccepted({ departmentId: department, profileId: 0 });

  useEffect(() => props.getAllDepartments(), []);

  // Refactor 2026-06-11: mặc định màn "CTKH đơn vị" hiển thị TOÀN TRƯỜNG
  // (departmentId=0) cho sudo-admin + nhân viên thường. Chỉ trưởng khoa
  // (faculty leader: type="khoachuyenmon" + roleInDepartment="leader") mới
  // default sang khoa của họ — vì họ quan tâm chính dữ liệu khoa mình.
  //
  // Trước đây luôn default về đơn vị đầu tiên người dùng thuộc → admin
  // QLKH/nhân sự không thuộc faculty cũng bị scope vào 1 khoa lạ và phải
  // tự đổi dropdown thành "Cả trường".
  useEffect(() => {
    if (!props.role) return;
    const myId = props.profileDetail?.id;
    const facultyLeader = (props.department || []).find((d) => {
      // 2026-08-14: "isFaculty" là field ma (backend không trả) → điều kiện
      // này luôn false, khiến Trưởng khoa luôn bị default về "Toàn trường"
      // thay vì đúng khoa mình. Dùng field thật `type === "khoachuyenmon"`.
      if (d?.type !== "khoachuyenmon") return false;
      const dp = d.departmentProfile?.find((item) => item.profileId === myId);
      return dp?.roleInDepartment?.toLowerCase() === "leader";
    });
    const nextId = facultyLeader ? facultyLeader.id : 0;
    setDepartment(nextId);
    props.setDepartment(nextId);
  }, [props.role, props.department, props.departments, props.profileDetail?.id]);

  useEffect(() => {
    const countScientificResearch =
      props.statisticUnacceptedDetailFilter?.numJournal +
      props.statisticUnacceptedDetailFilter?.numDomesticJournal +
      props.statisticUnacceptedDetailFilter?.numConference +
      props.statisticUnacceptedDetailFilter?.numDomesticConference +
      props.statisticUnacceptedDetailFilter?.numBook +
      props.statisticUnacceptedDetailFilter?.numOther;
    const countSolution = props.statisticUnacceptedDetailFilter?.numSolution || 0;
    const countPatent = props.statisticUnacceptedDetailFilter?.numPatent || 0;
    const countContract = props.statisticUnacceptedDetailFilter?.numProductContract || 0;
    const countProject = props.statisticUnacceptedDetailFilter?.numResearchProject || 0;
    const countMonograph = props.statisticUnacceptedDetailFilter?.numMonograph || 0;
    const countExhibition = props.statisticUnacceptedDetailFilter?.numExhibition || 0;
    const countAchievement = props.statisticUnacceptedDetailFilter?.numAchievement || 0;
    const countStudentGuidance = props.statisticUnacceptedDetailFilter?.numStudentGuidance || 0;
    const countScientificCouncil = props.statisticUnacceptedDetailFilter?.numScientificCouncil || 0;
    setCount({
      scientificResearch: countScientificResearch,
      solution: countSolution,
      patent: countPatent,
      contract: countContract,
      project: countProject,
      monograph: countMonograph,
      exhibition: countExhibition,
      achievement: countAchievement,
      studentGuidance: countStudentGuidance,
      scientificCouncilNew: countScientificCouncil,
    });
  }, [props.statisticUnacceptedDetailFilter]);

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        {...other}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {value === index && children}
      </div>
    );
  };
  const typeTable = "all";

  return (
    <>
      <Grid container justifyContent="space-between">
        <Grid item xs={10}>
          <Tabs 
            value={value} 
            textColor="secondary" 
            indicatorColor="secondary" 
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {props.tabList.map((tab) => (
              <Tab
                key={tab.key}
                label={
                  <Badge className="work-tab-badge" color="error" badgeContent={count[tab.key] || 0}>
                    {tab.title}
                  </Badge>
                }
                style={{ padding: "0 24px" }}
              />
            ))}
          </Tabs>
        </Grid>
        <Grid item xs={2}>
          {(() => {
            const baseList = props.role === "sudo-admin" ? props?.departments : props?.department;
            if (!baseList) return null;
            // Refactor 2026-06-11: thêm option "Cả trường" (id=0) đầu list để
            // user (sudo-admin / nhân viên không phải trưởng khoa) chọn xem
            // toàn trường — đồng bộ với default mới và tránh value=string ép
            // Autocomplete (gây warning + getOptionLabel crash).
            const departmentList = [{ id: 0, name: "Cả trường" }, ...baseList];
            return (
              <Autocomplete
                options={departmentList}
                getOptionLabel={(option) => option?.name || ""}
                getOptionSelected={(option, value) => option?.id === value?.id}
                disableClearable
                filterSelectedOptions
                onChange={(_, val) => handleChangeDepartment(val?.id || 0)}
                value={departmentList.find((e) => e.id === department) || departmentList[0]}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="Đơn vị"
                    variant="outlined"
                    placeholder="Cả trường"
                    style={{ float: "right", marginTop: 4, marginRight: 16 }}
                  />
                )}
              />
            );
          })()}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <TabPanel value={value} index={0}>
        <ScientificResearch adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Solution adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Patent adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      {/* disabled product contract */}
      {/* <TabPanel value={value} index={3}>
        <Contract type={typeTable} department={department} handleReload={handleReload}/>
      </TabPanel> */}
      <TabPanel value={value} index={3}>
        <Project adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Monograph adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Exhibition adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <Achievement adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <StudentGuidance adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <ScientificCouncilNew adminTab={true} type={typeTable} department={department} handleReload={handleReload} />
      </TabPanel>
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetchingAcceptedPatent: select(state, "patentReducer", "isFetchingAccepted"),
  isFetchingAcceptedProject: select(state, "projectReducer", "isFetchingAccepted"),
  isFetchingAcceptedSolution: select(state, "solutionReducer", "isFetchingAccepted"),
  isFetchingAcceptedContract: select(state, "contractReducer", "isFetchingAccepted"),
  isFetchingAcceptedMonograph: select(state, "monographReducer", "isFetchingAccepted"),
  isFetchingAcceptedExhibition: select(state, "exhibitionReducer", "isFetchingAccepted"),
  isFetchingAcceptedAchievement: select(state, "achievementReducer", "isFetchingAccepted"),
  isFetchingAcceptedStudentGuidance: select(state, "studentGuidanceReducer", "isFetchingAccepted"),
  isFetchingAcceptedScientificCouncil: select(state, "scientificCouncilNewReducer", "isFetchingAccepted"),
  isFetchingAcceptedScientificResearch: select(state, "scientificResearchReducer", "isFetchingAccepted"),
  isFetchingAcceptedScientificResearchOther: select(state, "scientificResearchOtherReducer", "isFetchingAccepted"),

  role: select(state, "userReducer", "role"),
  profileId: select(state, "userReducer", "userId"),
  // Refactor 2026-06-11: profileDetail để xác định trưởng khoa (so id với
  // departmentProfile.profileId của các đơn vị người dùng thuộc về).
  profileDetail: select(state, "profileReducer", "detail"),
  // list: select(state, "journalReducer", "listFiltered"),
  department: select(state, "profileReducer", "departments"),
  // defaultDepartment: select(state, "profileReducer", "department"),
  departments: select(state, "departmentReducer", "departments"),
  statisticUnacceptedDetailFilter: select(state, "profileReducer", "statisticUnacceptedDetailFilter"),
});

const mapDispatchToProps = (dispatch) => ({
  setDepartment: (id) => dispatch(setDepartment(id)),
  getAllDepartments: () => dispatch(getAllDepartments()),
  getProfileInfoByProfileId: (id) => dispatch(getProfileInfoByProfileId(id)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
});

const areEqual = (prevProps, nextProps) => {
  return (
    // prevProps.department === nextProps.department &&
    prevProps.departments.length === nextProps.departments.length &&
    // prevProps.handleChangeDepartment === nextProps.handleChangeDepartment &&
    prevProps.statisticUnacceptedDetailFilter?.numJournal === nextProps.statisticUnacceptedDetailFilter?.numJournal &&
    prevProps.statisticUnacceptedDetailFilter?.numDomesticJournal ===
      nextProps.statisticUnacceptedDetailFilter?.numDomesticJournal &&
    prevProps.statisticUnacceptedDetailFilter?.numConference ===
      nextProps.statisticUnacceptedDetailFilter?.numConference &&
    prevProps.statisticUnacceptedDetailFilter?.numDomesticConference ===
      nextProps.statisticUnacceptedDetailFilter?.numDomesticConference &&
    prevProps.statisticUnacceptedDetailFilter?.numBook === nextProps.statisticUnacceptedDetailFilter?.numBook &&
    prevProps.statisticUnacceptedDetailFilter?.numOther === nextProps.statisticUnacceptedDetailFilter?.numOther &&
    prevProps.statisticUnacceptedDetailFilter?.numSolution === nextProps.statisticUnacceptedDetailFilter?.numSolution &&
    prevProps.statisticUnacceptedDetailFilter?.numPatent === nextProps.statisticUnacceptedDetailFilter?.numPatent &&
    prevProps.statisticUnacceptedDetailFilter?.numProductContract ===
      nextProps.statisticUnacceptedDetailFilter?.numProductContract &&
    prevProps.statisticUnacceptedDetailFilter?.numResearchProject ===
      nextProps.statisticUnacceptedDetailFilter?.numResearchProject &&
    prevProps.statisticUnacceptedDetailFilter?.numMonograph ===
      nextProps.statisticUnacceptedDetailFilter?.numMonograph &&
    prevProps.statisticUnacceptedDetailFilter?.numExhibition ===
      nextProps.statisticUnacceptedDetailFilter?.numExhibition &&
    prevProps.statisticUnacceptedDetailFilter?.numAchievement ===
      nextProps.statisticUnacceptedDetailFilter?.numAchievement &&
    prevProps.statisticUnacceptedDetailFilter?.numStudentGuidance ===
      nextProps.statisticUnacceptedDetailFilter?.numStudentGuidance &&
    prevProps.statisticUnacceptedDetailFilter?.numScientificCouncil ===
      nextProps.statisticUnacceptedDetailFilter?.numScientificCouncil &&
    prevProps.isFetchingAcceptedScientificResearch === nextProps.isFetchingAcceptedScientificResearch &&
    prevProps.isFetchingAcceptedScientificResearchOther === nextProps.isFetchingAcceptedScientificResearchOther &&
    prevProps.isFetchingAcceptedSolution === nextProps.isFetchingAcceptedSolution &&
    prevProps.isFetchingAcceptedPatent === nextProps.isFetchingAcceptedPatent &&
    prevProps.isFetchingAcceptedContract === nextProps.isFetchingAcceptedContract &&
    prevProps.isFetchingAcceptedProject === nextProps.isFetchingAcceptedProject &&
    prevProps.isFetchingAcceptedMonograph === nextProps.isFetchingAcceptedMonograph &&
    prevProps.isFetchingAcceptedExhibition === nextProps.isFetchingAcceptedExhibition &&
    prevProps.isFetchingAcceptedAchievement === nextProps.isFetchingAcceptedAchievement &&
    prevProps.isFetchingAcceptedStudentGuidance === nextProps.isFetchingAcceptedStudentGuidance &&
    prevProps.isFetchingAcceptedScientificCouncil === nextProps.isFetchingAcceptedScientificCouncil
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(toJs(React.memo(ManagementTab, areEqual)));

